import { render, staticRenderFns } from "./activation-code.vue?vue&type=template&id=2f40d796&scoped=true&"
import script from "./activation-code.vue?vue&type=script&lang=js&"
export * from "./activation-code.vue?vue&type=script&lang=js&"
import style0 from "./activation-code.vue?vue&type=style&index=0&id=2f40d796&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f40d796",
  null
  
)

component.options.__file = "activation-code.vue"
export default component.exports